import type { TranslationKey } from "./en";

export const th: Partial<Record<TranslationKey, string>> = {
  "app.name": "ผู้ดูแลสภาพคล่อง",
  "language.label": "ภาษา",
  "language.english": "อังกฤษ",
  "language.thai": "ไทย",
  "common.loading": "กำลังโหลด…",
  "common.loadingAccounts": "กำลังโหลดบัญชี…",
  "common.loadingInstruments": "กำลังโหลดตราสาร…",
  "common.create": "สร้าง",
  "common.save": "บันทึก",
  "common.cancel": "ยกเลิก",
  "common.continue": "ถัดไป",
  "common.back": "ย้อนกลับ",
  "common.delete": "ลบ",
  "common.edit": "แก้ไข",
  "common.clear": "ล้าง",
  "common.loadMore": "โหลดเพิ่ม",
  "common.prev": "ก่อนหน้า",
  "common.next": "ถัดไป",
  "common.status": "สถานะ",
  "common.updated": "อัปเดต",
  "common.actions": "การดำเนินการ",
  "common.user": "ผู้ใช้",
  "common.market": "ตลาด",
  "common.order": "คำสั่ง",
  "common.trade": "รายการซื้อขาย",
  "common.price": "ราคา",
  "common.quantity": "จำนวน",
  "common.outcome": "ผลลัพธ์",
  "common.side": "ฝั่ง",
  "common.account": "บัญชี",
  "common.available": "คงเหลือ",
  "common.search": "ค้นหา",
  "common.yes": "ใช่",
  "common.no": "ไม่ใช่",
  "common.default": "ค่าเริ่มต้น",
  "common.directMarket": "ตลาดโดยตรง",
  "status.PAUSING": "กำลังหยุดพัก",
  "status.PAUSED": "หยุดพัก",
  "status.RESUMING": "กำลังรันต่อ",
  "status.RUNNING": "กำลังทำงาน",
  "status.STOPPING": "กำลังหยุด",
  "status.STOPPED": "หยุดแล้ว",
  "status.FAILED": "ล้มเหลว",
  "status.PENDING": "รอดำเนินการ",
  "status.ACTIVE": "ใช้งานอยู่",
  "status.INACTIVE": "ไม่ได้ใช้งาน",
  "status.SUSPENDED": "ถูกระงับ",
  "status.CLOSED": "ปิดแล้ว",
  "status.OPEN": "เปิดอยู่",
  "status.ORDER_CREATED": "สร้างคำสั่งแล้ว",
  "status.SENT_TO_ENGINE": "ส่งเข้าเอนจินแล้ว",
  "status.FILLED": "จับคู่ครบแล้ว",
  "status.PARTIALLY_FILLED": "จับคู่บางส่วน",
  "status.REJECTED": "ถูกปฏิเสธ",
  "status.CANCELED": "ยกเลิกแล้ว",
  "status.EXPIRED": "หมดอายุ",
  "status.CANCEL_PENDING": "กำลังรอยกเลิก",
  "status.PENDING_ENGINE": "กำลังรอเอนจิน",
  "status.RESERVED": "สำรองแล้ว",
  "reason.MANUAL": "หยุดด้วยตนเอง",
  "reason.SCHEDULED": "หยุดตามกำหนดเวลา",
  "reason.BUDGET": "ถึงขีดจำกัดงบประมาณ",
  "reason.FAILURE": "เกิดข้อผิดพลาด",
  "reason.SHUTDOWN": "บริการปิดตัว",
  "event.STARTED": "เริ่มทำงานแล้ว",
  "event.STOP_REQUESTED": "ร้องขอให้หยุดแล้ว",
  "event.STOPPED": "หยุดแล้ว",
  "event.FAILED": "ล้มเหลว",
  "event.BUDGET_PAUSED": "พักเพราะงบประมาณ",
  "event.BUDGET_RESUMED": "กลับมาทำงานหลังพักงบประมาณ",
  "event.INSTRUMENT_ADDED": "เพิ่มตราสารแล้ว",
  "event.INSTRUMENT_REMOVED": "นำตราสารออกแล้ว",
  "event.PLACE_OK": "ส่งคำสั่งสำเร็จ",
  "event.PLACE_FAIL": "ส่งคำสั่งล้มเหลว",
  "event.CANCEL_OK": "ยกเลิกคำสั่งสำเร็จ",
  "event.CANCEL_FAIL": "ยกเลิกคำสั่งล้มเหลว",
  "event.FILL": "จับคู่คำสั่งแล้ว",
  "event.NOTE": "หมายเหตุ",
  "event.FUNDING_INSUFFICIENT": "เงินทุนไม่เพียงพอ",
  "budgetSource.tracker": "ข้อมูลสด",
  "budgetSource.repo": "ภาพบันทึกที่จัดเก็บ",
  "paramKind.int": "จำนวนเต็ม",
  "paramKind.int64": "จำนวนเต็ม",
  "paramKind.percent": "เปอร์เซ็นต์",
  "paramKind.bps": "%",
  "paramKind.bool": "ใช่/ไม่ใช่",
  "paramKind.duration_ms": "มิลลิวินาที",
  "paramKind.ticks": "ช่วงราคา",
  "paramKind.price": "ราคา",
  "paramKind.string": "ข้อความ",
  "trading.buy": "ซื้อ",
  "trading.sell": "ขาย",
  "trading.yes": "ใช่",
  "trading.no": "ไม่ใช่",
  "nav.operate": "ดำเนินงาน",
  "nav.library": "คลังข้อมูล",
  "nav.overview": "ภาพรวม",
  "nav.runs": "รัน",
  "nav.accounts": "บัญชี",
  "nav.presets": "พรีเซ็ต",
  "nav.strategies": "กลยุทธ์",
  "nav.instruments": "ตราสาร",
  "nav.version": "ผู้ดูแล · v0.1",
  "nav.aria": "เมนูผู้ดูแลสภาพคล่อง",
  "topbar.openNavigation": "เปิดเมนู",
  "topbar.signOut": "ออกจากระบบ",
  "topbar.signingOut": "กำลังออกจากระบบ…",
  "login.operatorConsole": "คอนโซลผู้ปฏิบัติงาน",
  "login.brand": "ผู้ดูแลสภาพคล่อง · คอนโซลผู้ปฏิบัติงาน",
  "login.signIn": "เข้าสู่ระบบ",
  "login.subtitle": "ใช้อีเมลผู้ดูแลระบบเดียวกับระบบหลังบ้าน Smart Market",
  "login.email": "อีเมล",
  "login.password": "รหัสผ่าน",
  "login.continue": "ดำเนินการต่อ",
  "login.signingIn": "กำลังเข้าสู่ระบบ",
  "login.twoFactor": "ยืนยันตัวตนสองขั้นตอน",
  "login.enterCode": "กรอกรหัสยืนยัน",
  "login.codeInstruction": "เปิดแอปยืนยันตัวตนของ {email} แล้วกรอกรหัส 6 หลัก",
  "login.digitAria": "หลักที่ {digit} จาก 6",
  "login.verify": "ยืนยันและเข้าสู่ระบบ",
  "login.verifying": "กำลังยืนยัน",
  "login.back": "← กลับไปกรอกรหัสผ่าน",
  "login.error.codeRejected": "รหัสไม่ถูกต้อง โปรดตรวจสอบแอปยืนยันตัวตนแล้วลองอีกครั้ง",
  "login.error.credentials": "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
  "login.error.rateLimit": "ลองหลายครั้งเกินไป โปรดรอสักครู่แล้วลองใหม่",
  "login.error.unreachable": "ไม่สามารถเชื่อมต่อระบบหลังบ้านได้ โปรดตรวจสอบคลัสเตอร์แล้วลองใหม่",
  "login.error.verify": "ยืนยันตัวตนไม่สำเร็จ",
  "login.error.signIn": "เข้าสู่ระบบไม่สำเร็จ",
  "login.error.noFactor": "ต้องยืนยันตัวตนสองขั้นตอน แต่ยังไม่มีปัจจัยที่ใช้งานอยู่ โปรดให้ผู้ดูแลระบบสูงสุดลงทะเบียนให้",
  "overview.subtitle": "ควบคุมกลุ่มสภาพคล่อง — เริ่ม หยุด และติดตามการรัน",
  "overview.defaultPreset": "พรีเซ็ตเริ่มต้น",
  "overview.strategyMakers": "กลยุทธ์ {strategy} · ผู้สร้างสภาพคล่อง {makers} บัญชี",
  "overview.takers": ", ผู้รับสภาพคล่อง {count} บัญชี",
  "overview.noDefault": "ยังไม่ได้ตั้งพรีเซ็ตเริ่มต้น",
  "overview.authorOne": "สร้างพรีเซ็ต",
  "overview.orSetDefault": "หรือตั้งพรีเซ็ตที่มีอยู่เป็นค่าเริ่มต้น",
  "overview.activeRuns": "รันที่ทำงานอยู่",
  "overview.fleetIdle": "ระบบยังว่าง เริ่มรันจากหน้ารัน",
  "overview.runsDriving": "มี {count} รันกำลังสร้างสภาพคล่อง",
  "overview.quickActions": "ทางลัด",
  "overview.viewRuns": "ดูรันทั้งหมด →",
  "overview.editPresets": "แก้ไขพรีเซ็ต →",
  "overview.browseStrategies": "ดูกลยุทธ์ →",
  "overview.recentRuns": "รันล่าสุด",
  "overview.viewAll": "ดูทั้งหมด",
  "overview.noRuns": "ยังไม่มีรัน เริ่มได้จากหน้ารัน",
  "overview.runId": "รหัสรัน",
  "overview.strategy": "กลยุทธ์",
  "overview.started": "เริ่มเมื่อ",
  "overview.stopped": "หยุดเมื่อ",
  "accounts.title": "บัญชีผู้ดูแลสภาพคล่อง",
  "accounts.subtitle": "เลือกบัญชีในพรีเซ็ตเพื่อกำหนดผู้ใช้ที่ดำเนินงานบอตสร้างสภาพคล่อง",
  "accounts.name": "ชื่อบัญชี",
  "accounts.namePlaceholder": "แคมเปญฤดูร้อน 2026",
  "accounts.codeSuffix": "ส่วนท้ายรหัส",
  "accounts.fullCode": "รหัสเต็ม: SYSTEM_MM.{suffix}",
  "accounts.codeHint": "ใช้ตัวอักษรพิมพ์ใหญ่ ตัวเลข _ . - เท่านั้น",
  "accounts.purpose": "วัตถุประสงค์ (ไม่บังคับ)",
  "accounts.purposePlaceholder": "งบสำหรับแคมเปญฤดูร้อน",
  "accounts.initialFunding": "เงินทุนเริ่มต้น",
  "accounts.selectable": "บัญชีที่เลือกได้",
  "accounts.count": "{count} บัญชี",
  "accounts.searchPlaceholder": "อีเมล ชื่อ หรือรหัสผู้ใช้",
  "accounts.bot": "บอต",
  "accounts.platformFee": "ค่าธรรมเนียมแพลตฟอร์ม",
  "accounts.userId": "รหัสผู้ใช้",
  "accounts.brokerAccount": "บัญชีโบรกเกอร์",
  "accounts.brokerId": "โบรกเกอร์",
  "accounts.brokerAccountMismatch": "ยอดนี้อ่านมาจากบัญชีโบรกเกอร์คนละบัญชีกับที่แสดงอยู่ โปรดรีเฟรชก่อนย้ายเงิน",
  "accounts.unnamed": "บัญชีผู้ดูแลสภาพคล่องไม่มีชื่อ",
  "accounts.unknownStrategy": "ไม่ทราบกลยุทธ์",
  "accounts.run": "รัน {id}…",
  "accounts.idle": "ว่าง",
  "accounts.noMatch": "ไม่พบบัญชีผู้ดูแลสภาพคล่องที่ตรงกับคำค้น",
  "accounts.editFee": "แก้ไขค่าธรรมเนียมแพลตฟอร์ม",
  "accounts.makerFee": "ค่าธรรมเนียมผู้สร้างสภาพคล่อง %",
  "accounts.takerFee": "ค่าธรรมเนียมผู้รับสภาพคล่อง %",
  "accounts.feeSummary": "ผู้สร้าง {maker}% / ผู้รับ {taker}%",
  "accounts.error.create": "สร้างไม่สำเร็จ",
  "accounts.error.updateFees": "อัปเดตค่าธรรมเนียมไม่สำเร็จ",
  "accounts.executionAvailable": "ยอดพร้อมใช้สำหรับส่งคำสั่ง",
  "accounts.executionReserved": "ถูกกันไว้",
  "accounts.executionReservedHint": "ถูกกันไว้โดยคำสั่งที่ยังเปิดอยู่",
  "accounts.fundingReserve": "เงินสำรองสำหรับเติมทุน",
  "accounts.fundingReserveHint": "ต้องโอนเข้าบัญชีส่งคำสั่งก่อนจึงจะใช้เทรดได้",
  "accounts.linkUnlinked": "ยังไม่ได้เชื่อมโยง",
  "accounts.linkUnlinkedHint": "บัญชีนี้ยังไม่มีเงินสำรองที่เชื่อมโยงไว้ กรุณาให้ผู้ดูแลระบบรันการเชื่อมโยงย้อนหลัง หรือกำหนดบัญชีลูก SYSTEM_MM ในระบบหลังบ้าน",
  "accounts.linkInvalid": "การเชื่อมโยงไม่ถูกต้อง",
  "accounts.linkInvalidHint": "ไม่พบเงินสำรองที่เชื่อมโยงไว้ หรือใช้งานไม่ได้ กรุณาตรวจสอบบัญชีลูก SYSTEM_MM ในหน้าคลังของระบบหลังบ้าน",
  "accounts.balanceUnavailable": "อ่านค่าไม่ได้",
  "accounts.balanceUnavailableHint": "ไม่สามารถอ่านยอดนี้ได้ ซึ่งไม่ได้แปลว่ายอดเป็นศูนย์",
  "accounts.transfer.open": "โอนระหว่างบัญชี",
  "accounts.transfer.title": "โอนยอดสำหรับส่งคำสั่ง",
  "accounts.transfer.subtitle": "ย้ายยอดพร้อมใช้สำหรับส่งคำสั่งจากบัญชีผู้ดูแลสภาพคล่องหนึ่งไปยังอีกบัญชีหนึ่ง โดยไม่แตะเงินสำรองสำหรับเติมทุน",
  "accounts.transfer.from": "จาก",
  "accounts.transfer.to": "ไปยัง",
  "accounts.transfer.pick": "เลือกบัญชี{side}",
  "accounts.transfer.amount": "จำนวนเงิน",
  "accounts.transfer.amountHint": "ยอดพร้อมใช้สำหรับส่งคำสั่ง: {available}",
  "accounts.transfer.amountNoSource": "เลือกบัญชีต้นทางเพื่อดูยอดที่พร้อมใช้",
  "accounts.transfer.max": "สูงสุด",
  "accounts.transfer.insufficient": "เกินยอดพร้อมใช้ของบัญชีต้นทาง",
  "accounts.transfer.reason": "เหตุผล",
  "accounts.transfer.reasonPlaceholder": "ปรับสมดุลก่อนรอบเย็น",
  "accounts.transfer.reasonHint": "จะถูกบันทึกไว้ในประวัติบัญชีแยกประเภทของทั้งสองบัญชี",
  "accounts.transfer.sameAccount": "บัญชีต้นทางและปลายทางต้องไม่ใช่บัญชีเดียวกัน",
  "accounts.transfer.reservedNotTransferable": "โอนไม่ได้",
  "accounts.transfer.onActiveRun": "กำลังรันบอต",
  "accounts.transfer.activeRunWarning": "มีบัญชีที่กำลังรันบอตอยู่ ระบบจะไม่หยุดรันให้ แต่การย้ายยอดพร้อมใช้จะทำให้ความสามารถในการตั้งคำสั่งเปลี่ยนไป",
  "accounts.transfer.noEligible": "ไม่มีบัญชีที่ใช้ได้ บัญชีต้องอ่านยอดสำหรับส่งคำสั่งได้จึงจะร่วมการโอนได้",
  "accounts.transfer.confirm": "ยืนยันการโอน",
  "accounts.transfer.afterSource": "ต้นทางหลังโอน",
  "accounts.transfer.afterDestination": "ปลายทางหลังโอน",
  "accounts.transfer.estimateHint": "เป็นค่าประมาณ คำสั่งที่เปิดอยู่อาจจับคู่ก่อนการโอนจะเสร็จ",
  "accounts.transfer.error": "การโอนไม่สำเร็จ",
  "accounts.transfer.done": "โอนสำเร็จ ระบบได้รีเฟรชยอดของทั้งสองบัญชีแล้ว",
  "accounts.transfer.crossBroker": "สองบัญชีนี้อยู่คนละโบรกเกอร์ การโอนข้ามโบรกเกอร์ทำไม่ได้",
  "accounts.transfer.refreshAccounts": "รีเฟรชบัญชี",
  "accounts.transfer.refreshHint": "การรีเฟรชจะพากลับไปที่แบบฟอร์ม ตรวจสอบทั้งสองบัญชี แล้วกดดำเนินการต่อเพื่อยืนยันการโอนใหม่",
  "accounts.return.open": "คืนเข้าเงินสำรอง",
  "accounts.return.openHint": "ย้ายยอดพร้อมใช้สำหรับส่งคำสั่งกลับไปยังเงินสำรองที่เชื่อมโยงกับบัญชีนี้",
  "accounts.return.title": "คืนยอดสำหรับส่งคำสั่ง",
  "accounts.return.subtitle": "ย้ายยอดพร้อมใช้สำหรับส่งคำสั่งจาก {account} กลับไปยังเงินสำรอง SYSTEM_MM ที่เชื่อมโยงไว้",
  "accounts.return.executionAccount": "บัญชีส่งคำสั่ง",
  "accounts.return.destination": "เงินสำรองที่เชื่อมโยง",
  "accounts.return.noReserve": "ไม่มีเงินสำรองที่เชื่อมโยง",
  "accounts.return.amount": "จำนวนเงิน",
  "accounts.return.amountHint": "ยอดพร้อมใช้สำหรับส่งคำสั่ง: {available}",
  "accounts.return.balanceUnavailable": "ไม่สามารถอ่านยอดสำหรับส่งคำสั่งได้ กรุณารีเฟรชก่อนคืนเงิน",
  "accounts.return.max": "สูงสุด",
  "accounts.return.insufficient": "จำนวนเงินเกินยอดพร้อมใช้ของบัญชีส่งคำสั่งนี้",
  "accounts.return.reason": "เหตุผล",
  "accounts.return.reasonPlaceholder": "คืนงบที่ไม่ได้ใช้หลังจบรัน",
  "accounts.return.reasonHint": "จำเป็นต้องระบุและจะถูกบันทึกในประวัติการตรวจสอบ",
  "accounts.return.activeRunWarning": "บัญชีนี้กำลังรันบอตอยู่ ระบบจะไม่หยุดรัน แต่การคืนเงินจะลดวงเงินที่ใช้ตั้งคำสั่ง",
  "accounts.return.linkUnavailable": "ต้องมีเงินสำรอง SYSTEM_MM ที่เชื่อมโยงไว้อย่างถูกต้อง",
  "accounts.return.empty": "ไม่มียอดพร้อมใช้สำหรับส่งคำสั่งให้คืน",
  "accounts.return.executionAfter": "ยอดส่งคำสั่งหลังคืน",
  "accounts.return.reserveAfter": "เงินสำรองหลังคืน",
  "accounts.return.confirmHint": "ระบบจะย้ายเฉพาะยอดพร้อมใช้สำหรับส่งคำสั่ง เงินที่กันไว้สำหรับคำสั่งเปิดจะยังอยู่ในบัญชีส่งคำสั่ง",
  "accounts.return.confirm": "คืนเข้าเงินสำรอง",
  "accounts.return.error": "ไม่สามารถคืนยอดสำหรับส่งคำสั่งได้",
  "accounts.return.done": "คืนยอดสำหรับส่งคำสั่งแล้ว ระบบได้รีเฟรชยอดบัญชีส่งคำสั่งและเงินสำรอง",
  "accounts.reserveBalances.aria": "ยอดเงินสำรองแยกตามสกุลเงิน",
  "accounts.reserveBalances.notProvisioned": "ยังไม่มีกระเป๋า",
  "accounts.reserveBalances.notProvisionedHint": "บัญชีสำรองนี้ไม่มีกระเป๋า {currency} จึงไม่ได้ถือ {currency} เลย ซึ่งไม่ได้แปลว่ายอดเป็นศูนย์",
  "accounts.reserveBalances.dialogTitle": "ยอดเงินสำรอง",
  "accounts.reserveBalances.dialogHint": "ระบบจะโอนและตรวจยอดเฉพาะสกุลเงินที่เลือกไว้เท่านั้น",
  "accounts.reserveCurrency.presentHint": "บัญชีสำรองนี้มีกระเป๋า {currency} แล้ว",
  "accounts.reserveCurrency.repair": "เพิ่มกระเป๋าที่ขาด",
  "accounts.reserveCurrency.repairHint": "สร้างกระเป๋า {currencies} ที่บัญชีสำรองนี้ยังไม่มี กระเป๋าที่สร้างจะเริ่มต้นที่ศูนย์และไม่มีการโอนเงินใด ๆ และรันโหมด GAME จะใช้บัญชีสำรองนี้ไม่ได้จนกว่าจะมีกระเป๋าดังกล่าว",
  "accounts.reserveCurrency.repairing": "กำลังเพิ่มกระเป๋า…",
  "accounts.reserveCurrency.repaired": "ซ่อมสกุลเงินของบัญชีสำรองแล้ว สร้างกระเป๋าใหม่ {provisioned} กระเป๋า โดยแต่ละกระเป๋าเริ่มต้นที่ศูนย์",
  "accounts.reserveCurrency.repairedWithFailures": "ซ่อมสกุลเงินของบัญชีสำรองได้บางส่วน สร้างกระเป๋าใหม่ {provisioned} กระเป๋า และยังขาดอีก {missing} กระเป๋า กรุณาตรวจสอบว่าบัญชีแม่ SYSTEM_MM มีกระเป๋าในสกุลเงินนั้นแล้ว",
  "accounts.reserveCurrency.error": "ไม่สามารถสร้างกระเป๋าสกุลเงินที่บัญชีสำรองยังขาดได้",
  "accounts.reserve.fundOpen": "เติมยอดส่งคำสั่ง",
  "accounts.reserve.parentOpen": "ย้ายไปบัญชีแม่",
  "accounts.reserve.fundOpenHint": "ย้ายเงินสำรองนี้เข้ากระเป๋าส่งคำสั่งที่เชื่อมโยงไว้",
  "accounts.reserve.parentOpenHint": "ย้ายเงินสำรองของบัญชีลูกกลับไปยังบัญชีแม่ SYSTEM_MM",
  "accounts.reserve.linkUnavailable": "ต้องมีเงินสำรอง SYSTEM_MM ที่เชื่อมโยงไว้อย่างถูกต้อง",
  "accounts.reserve.balanceUnavailable": "ไม่สามารถอ่านเงินสำรองสำหรับเติมทุนได้ กรุณารีเฟรชก่อนย้ายเงิน",
  "accounts.reserve.empty": "ไม่มีเงินสำรองพร้อมใช้ให้ย้าย",
  "accounts.reserve.fundTitle": "เติมเงินเข้ากระเป๋าส่งคำสั่ง",
  "accounts.reserve.parentTitle": "ย้ายเงินสำรองไปบัญชีแม่",
  "accounts.reserve.fundSubtitle": "ย้ายเงินสำรองพร้อมใช้เข้ากระเป๋าส่งคำสั่งที่เชื่อมโยงกับ {account}",
  "accounts.reserve.parentSubtitle": "ย้ายเงินสำรองพร้อมใช้จากบัญชีลูกของ {account} กลับไปยังบัญชีแม่ SYSTEM_MM",
  "accounts.reserve.source": "เงินสำรองสำหรับเติมทุน",
  "accounts.reserve.destination": "ปลายทาง",
  "accounts.reserve.executionDestination": "กระเป๋าส่งคำสั่งของ {account}",
  "accounts.reserve.amount": "จำนวนเงิน",
  "accounts.reserve.amountHint": "เงินสำรองพร้อมใช้: {available}",
  "accounts.reserve.insufficient": "จำนวนเงินเกินเงินสำรองพร้อมใช้ของบัญชีนี้",
  "accounts.reserve.max": "สูงสุด",
  "accounts.reserve.reason": "เหตุผล",
  "accounts.reserve.fundReasonPlaceholder": "เติมยอดส่งคำสั่งสำหรับรอบถัดไป",
  "accounts.reserve.parentReasonPlaceholder": "คืนเงินสำรองที่ไม่ได้ใช้ไปยังบัญชีแม่",
  "accounts.reserve.reasonHint": "จำเป็นต้องระบุและจะถูกบันทึกในประวัติการตรวจสอบ",
  "accounts.reserve.reserveAfter": "เงินสำรองหลังโอน",
  "accounts.reserve.executionAfter": "ยอดส่งคำสั่งหลังเติมเงิน",
  "accounts.reserve.parentReceives": "บัญชีแม่ได้รับ",
  "accounts.reserve.fundConfirmHint": "ระบบจะย้ายเงินสำรองพร้อมใช้เข้ากระเป๋าส่งคำสั่ง เงินส่งคำสั่งที่ถูกกันไว้จะไม่เปลี่ยนแปลง",
  "accounts.reserve.parentConfirmHint": "ระบบจะย้ายเงินสำรองพร้อมใช้ของบัญชีลูกไปยังบัญชีแม่ SYSTEM_MM กระเป๋าส่งคำสั่งจะไม่เปลี่ยนแปลง",
  "accounts.reserve.fundConfirm": "เติมยอดส่งคำสั่ง",
  "accounts.reserve.parentConfirm": "ย้ายไป SYSTEM_MM",
  "accounts.reserve.fundError": "ไม่สามารถเติมเงินเข้ากระเป๋าส่งคำสั่งได้",
  "accounts.reserve.parentError": "ไม่สามารถย้ายเงินสำรองไปยังบัญชีแม่ SYSTEM_MM ได้",
  "accounts.reserve.fundDone": "เติมยอดส่งคำสั่งแล้ว ระบบได้รีเฟรชยอดส่งคำสั่งและเงินสำรอง",
  "accounts.reserve.parentDone": "ย้ายเงินสำรองไปยังบัญชีแม่ SYSTEM_MM แล้ว ระบบได้รีเฟรชเงินสำรองบัญชีลูก",
  "accounts.createdNotFunded": "สร้างบัญชีแล้ว เงินสำรองถูกเชื่อมโยงแล้วแต่ยังใช้เทรดไม่ได้ กรุณาโอนเข้าบัญชีส่งคำสั่งก่อนเริ่มรัน",
  "presets.title": "พรีเซ็ต",
  "presets.subtitle": "เทมเพลตที่ตั้งชื่อไว้ แต่ละพรีเซ็ตเก็บกลยุทธ์ พูล บันไดราคา งบ และกำหนดเวลา",
  "presets.new": "พรีเซ็ตใหม่",
  "presets.startError": "เริ่มรันไม่สำเร็จ",
  "presets.emptyBefore": "ยังไม่มีพรีเซ็ต",
  "presets.createOne": "สร้างพรีเซ็ต",
  "presets.emptyAfter": "หรือเริ่มบริการผู้ดูแลสภาพคล่องใหม่เพื่อสร้างค่าเริ่มต้นจากตัวแปรสภาพแวดล้อม",
  "presets.name": "ชื่อ",
  "presets.strategy": "กลยุทธ์",
  "presets.pools": "พูล",
  "presets.poolSummary": "เสนอซื้อ {bid} / เสนอขาย {ask} / ผู้รับสภาพคล่อง {taker}",
  "presets.start": "เริ่ม",
  "presets.duplicate": "ทำสำเนา",
  "presets.setDefault": "ตั้งเป็นค่าเริ่มต้น",
  "presets.deleteConfirm": "ลบพรีเซ็ต “{name}” หรือไม่? รายการนี้ยังกู้คืนได้เพราะระบบยังไม่ลบข้อมูลถาวร",
  "preset.newTitle": "พรีเซ็ตใหม่",
  "preset.newBreadcrumb": "ใหม่",
  "preset.newSubtitle": "สร้างชุดการตั้งค่ารัน ระบบจะบันทึกค่า ณ ตอนเริ่มรัน การแก้ไขภายหลังจึงไม่กระทบรันที่ทำงานอยู่",
  "preset.create": "สร้างพรีเซ็ต",
  "preset.save": "บันทึกการเปลี่ยนแปลง",
  "preset.error.create": "สร้างไม่สำเร็จ",
  "preset.error.update": "อัปเดตไม่สำเร็จ",
  "editor.identity": "ข้อมูลพื้นฐาน",
  "editor.name": "ชื่อ",
  "editor.namePlaceholder": "เช่น polymarket-default",
  "editor.description": "คำอธิบาย",
  "editor.descriptionPlaceholder": "บริบทเพิ่มเติมสำหรับผู้ปฏิบัติงาน",
  "editor.strategy": "กลยุทธ์",
  "editor.strategyName": "ชื่อกลยุทธ์",
  "editor.pools": "พูล",
  "editor.inventoryMode": "โหมดสินทรัพย์คงเหลือ",
  "editor.singleInventory": "บัญชีสินทรัพย์คงเหลือเดียว",
  "editor.singleInventoryHint": "ใช้บัญชีผู้สร้างสภาพคล่องเดียวร่วมกันทั้งฝั่งเสนอซื้อและเสนอขาย",
  "editor.takerMode": "โหมดผู้รับสภาพคล่อง",
  "editor.enableTakers": "เปิดใช้บัญชีผู้รับสภาพคล่อง",
  "editor.enableTakersHint": "เมื่อเปิดใช้ ให้เลือกบัญชีผู้รับสภาพคล่องที่ส่งคำสั่งข้ามส่วนต่างราคาได้",
  "editor.maxLoss": "ขาดทุนสูงสุด",
  "editor.riskBudget": "งบความเสี่ยง",
  "editor.initialFunding": "เงินทุนเริ่มต้น",
  "editor.executionAccounts": "บัญชีดำเนินการ",
  "editor.executionHint": "เว้นบัญชีผู้สร้างสภาพคล่องว่างเพื่อให้ระบบสร้างบัญชีตามรูปแบบอัตโนมัติ",
  "editor.sharedMaker": "บัญชีผู้สร้างสภาพคล่องที่ใช้ร่วมกัน",
  "editor.takersSelected": "ผู้รับสภาพคล่อง (เลือก {count})",
  "editor.selectTakerValidation": "เลือกบัญชีผู้รับสภาพคล่องอย่างน้อยหนึ่งบัญชีก่อนบันทึก",
  "editor.fairValue": "มูลค่ายุติธรรม",
  "editor.initRange": "ช่วงเริ่มต้น %",
  "editor.drift": "การเลื่อน (ส่วนในหมื่น)",
  "editor.reversion": "การย้อนกลับ %",
  "editor.takerLoop": "รอบการทำงานของผู้รับสภาพคล่อง",
  "editor.interval": "ช่วงเวลา (มิลลิวินาที)",
  "editor.ordersPerTick": "คำสั่ง / รอบ",
  "editor.qtyMin": "จำนวนต่ำสุด",
  "editor.qtyMax": "จำนวนสูงสุด",
  "editor.offsetTicks": "ระยะเหลื่อม (ช่วงราคา)",
  "editor.buyBias": "น้ำหนักฝั่งซื้อ %",
  "editor.quoteManagement": "การจัดการราคาเสนอ",
  "editor.replenish": "เติมราคาเสนอของผู้สร้างสภาพคล่องที่ถูกจับคู่บางส่วน",
  "editor.replenishThreshold": "เกณฑ์เติม %",
  "editor.inFlightGrace": "ช่วงผ่อนผันระหว่างดำเนินการ (มิลลิวินาที)",
  "editor.sellPolicy": "นโยบายการขาย",
  "editor.allowUncovered": "อนุญาตขายผลลัพธ์ใช่โดยไม่มีสินทรัพย์รองรับ",
  "editor.fallback": "แผนสำรอง",
  "editor.buyOpposite": "ซื้อผลลัพธ์ฝั่งตรงข้าม",
  "editor.partialInventory": "สินทรัพย์คงเหลือบางส่วน",
  "editor.split": "แยก",
  "editor.schedule": "กำหนดเวลา",
  "editor.scheduleHint": "เว้นว่างเพื่อเริ่มทันที / ทำงานจนกว่าจะสั่งหยุด เวลาใช้เขตเวลาท้องถิ่นและบันทึกเป็นเวลาสากล (UTC)",
  "editor.startAt": "เริ่มเมื่อ",
  "editor.endAt": "สิ้นสุดเมื่อ",
  "editor.instruments": "ตราสาร",
  "editor.mode": "โหมด",
  "editor.allOpen": "ตราสารที่เปิดซื้อขายทั้งหมด",
  "editor.allowlist": "รายการอนุญาต (เลือกด้านล่าง)",
  "editor.event": "อีเวนต์",
  "editor.market": "ตลาด",
  "editor.id": "รหัส",
  "editor.noInstruments": "ไม่มีตราสารที่เปิดซื้อขายให้เลือก",
  "editor.budgets": "งบประมาณ",
  "editor.budgetsHint": "เพดานต่อขอบเขต ค่า 0 หมายถึงไม่จำกัด มูลค่าตามสัญญาคือราคา × จำนวนในหน่วยย่อย เพดานรวมจะหยุดรัน ส่วนเพดานย่อยจะพักเฉพาะขอบเขตนั้น",
  "editor.scope.global": "ทั้งหมด",
  "editor.scope.maker": "ผู้สร้างสภาพคล่อง",
  "editor.scope.taker": "ผู้รับสภาพคล่อง",
  "editor.maxOrders": "คำสั่งสูงสุด",
  "editor.maxNotional": "มูลค่าตามสัญญาสูงสุด",
  "editor.engineCadence": "จังหวะเอนจิน",
  "editor.discovery": "ค้นหา (มิลลิวินาที)",
  "editor.refresh": "รีเฟรช (มิลลิวินาที)",
  "editor.jitter": "ช่วงสุ่ม (มิลลิวินาที)",
  "editor.depthLevels": "ระดับความลึก",
  "editor.minSpread": "ส่วนต่างราคาต่ำสุด (ช่วงราคา)",
  "editor.orderMode": "โหมดคำสั่ง",
  "editor.orderModeInternal": "ภายใน (ส่งคำสั่งตรง)",
  "editor.orderModeOpenApi": "OpenAPI (ยืนยันคำขอผ่านเกตเวย์ — ยังไม่เปิดใช้)",
  "editor.generatedAccount": "รูปแบบบัญชีที่สร้างอัตโนมัติ",
  "editor.accountSelectedHint": "ผู้ใช้ที่เลือกจะได้รับบทบาทผู้ดูแลสภาพคล่องและเงินทุนตอนเริ่มรัน",
  "editor.reserveNotReady": "บัญชีสำรองของบัญชีนี้ยังไม่มีกระเป๋า {currencies} จึงใช้รันโหมด {mode} ไม่ได้ กรุณาซ่อมที่หน้าบัญชี",
  "editor.noAccounts": "ยังไม่มีบัญชีผู้ดูแลสภาพคล่อง",
  "editor.sparkHint": "ทศนิยมสูงสุด 2 ตำแหน่ง (เช่น 100.00)",
  "instruments.title": "ตราสาร",
  "instruments.subtitle": "ภาพรวมกฎที่เปิดซื้อขายล่าสุด เลือกพรีเซ็ตและตราสารสำหรับรันในอนาคต รันที่ทำงานอยู่ยังใช้ภาพบันทึกเดิม",
  "instruments.preset": "พรีเซ็ต",
  "instruments.mode": "โหมด",
  "instruments.allRules": "กฎที่เปิดซื้อขายทั้งหมด",
  "instruments.allowlist": "รายการอนุญาต (เฉพาะที่เลือก)",
  "instruments.selected": "เลือก {count}",
  "instruments.empty": "ไม่มีตราสารที่เปิดซื้อขาย โปรดเปิดในแค็ตตาล็อกระบบหลังบ้านก่อนเริ่มรัน",
  "instruments.instrument": "ตราสาร",
  "instruments.rule": "กฎ",
  "instruments.tick": "ช่วงราคา",
  "instruments.lot": "ขนาดชุด",
  "instruments.priceMin": "ราคาต่ำสุด",
  "instruments.priceMax": "ราคาสูงสุด",
  "instruments.includeAria": "รวม {id}",
  "instruments.saveFailed": "บันทึกไม่สำเร็จ: {message}",
  "strategies.title": "กลยุทธ์",
  "strategies.subtitle": "แค็ตตาล็อกเชิงปริมาณ แต่ละกลยุทธ์สร้างบันไดคำสั่งครบชุดในแต่ละรอบรีเฟรช และเพิ่มบันไดสำรองด้านนอกเพื่อความปลอดภัยได้",
  "strategies.composite": "แบบผสม",
  "strategies.composes": "ประกอบด้วย:",
  "strategies.parameters": "พารามิเตอร์",
  "strategies.default": "ค่าเริ่มต้น {value}",
  "strategies.constantSpread.title": "สเปรดคงที่",
  "strategies.constantSpread.description": "วางบันไดราคาแบบสมมาตรรอบราคากลาง เหมาะสำหรับเริ่มตลาดด้วยรูปแบบที่คาดการณ์ได้",
  "strategies.midpointFollow.title": "ติดตามราคากลาง",
  "strategies.midpointFollow.description": "ติดตามราคากลางของสมุดคำสั่ง และใช้มูลค่ายุติธรรมเริ่มต้นเมื่อสมุดว่าง",
  "strategies.randomWalk.title": "สุ่มเคลื่อนราคา",
  "strategies.randomWalk.description": "เลื่อนราคาฐานแบบสุ่มพร้อมแรงดึงกลับ เหมาะก่อนตลาดมีคำสั่งตามธรรมชาติ",
  "strategies.ghostLadder.title": "บันไดสำรอง",
  "strategies.ghostLadder.description": "เพิ่มความลึกสำรองด้านนอกสำหรับคำสั่งผู้รับสภาพคล่องขนาดใหญ่ เหมาะใช้ร่วมกับกลยุทธ์ชั้นใน",
  "strategies.lmsrOrganicSkew.title": "LMSR ปรับตามสินทรัพย์คงเหลือ",
  "strategies.lmsrOrganicSkew.description": "คำนวณราคาจากอุปสงค์สะสมของ LMSR และปรับตามสินทรัพย์คงเหลือกับสัดส่วนคำสั่งธรรมชาติในสมุด",
  "strategies.midpointGhost.title": "ติดตามราคากลาง + บันไดสำรอง",
  "strategies.midpointGhost.description": "ติดตามราคากลางในชั้นในและใช้บันไดสำรองด้านนอก เป็นค่าแนะนำสำหรับตลาดจริงที่มีคำสั่งธรรมชาติ",
  "strategies.randomGhost.title": "สุ่มเคลื่อนราคา + บันไดสำรอง",
  "strategies.randomGhost.description": "สุ่มเคลื่อนราคาในชั้นในและใช้บันไดสำรองด้านนอก ช่วยให้กราฟก่อนเปิดตลาดเคลื่อนไหวต่อเนื่อง",
  "strategyParam.levels": "ระดับต่อฝั่ง",
  "strategyParam.spread_ticks": "ส่วนต่างราคา (ช่วงราคา)",
  "strategyParam.step_ticks": "ระยะห่าง (ช่วงราคา)",
  "strategyParam.size_per_level": "ขนาดต่อระดับ",
  "strategyParam.size_decay_percent": "อัตราลดขนาด (%)",
  "strategyParam.jitter_bps": "การแกว่งราคา (% ของช่วงราคา)",
  "strategyParam.size_skew_percent": "ความเอียงของขนาด (%)",
  "strategyParam.min_spread_ticks": "ส่วนต่างราคาต่ำสุด (ช่วงราคา)",
  "strategyParam.drift_bps": "ขนาดการเลื่อน (% ของช่วงราคา)",
  "strategyParam.max_loss_budget": "งบขาดทุนสูงสุด",
  "strategyParam.initial_yes_probability_bps": "ความน่าจะเป็นผลลัพธ์ใช่เริ่มต้น",
  "strategyParam.bid_ask_spread_bps": "ส่วนต่างราคาเสนอซื้อ/เสนอขาย",
  "strategyParam.skew_sensitivity_bps": "ความไวต่อสินทรัพย์คงเหลือ",
  "strategyParam.inventory_max": "สินทรัพย์คงเหลือสูงสุด",
  "strategyParam.price_floor_bps": "ราคาต่ำสุด",
  "runs.title": "รัน",
  "runs.subtitle": "รันทั้งหมดเรียงจากใหม่ไปเก่า รันที่ทำงานอยู่รีเฟรชอัตโนมัติ ส่วนรันสิ้นสุดเก็บไว้เป็นประวัติ",
  "runs.startFromPreset": "เริ่มรันจากพรีเซ็ต →",
  "runs.filter.all": "ทั้งหมด",
  "runs.filter.running": "กำลังทำงาน",
  "runs.filter.stopped": "หยุดแล้ว",
  "runs.filter.failed": "ล้มเหลว",
  "runs.emptyBefore": "ไม่มีรันตรงกับตัวกรอง เริ่มรันได้จาก",
  "runs.presetsPage": "หน้าพรีเซ็ต",
  "runs.run": "รัน",
  "runs.reason": "เหตุผล",
  "runs.presetFallback": "พรีเซ็ต {id}…",
  "runs.adHoc": "รันเฉพาะกิจ",
  "run.strategy": "กลยุทธ์",
  "run.preset": "พรีเซ็ต",
  "run.stop": "หยุดรัน",
  "run.stopConfirm": "หยุดรันนี้หรือไม่? ระบบจะพยายามยกเลิกคำสั่งที่เปิดอยู่",
  "run.error.stop": "หยุดรันไม่สำเร็จ",
  "run.error.reported": "รันรายงานข้อผิดพลาด",
  "run.started": "เริ่มเมื่อ",
  "run.requested": "ร้องขอเมื่อ {time}",
  "run.stopped": "หยุดเมื่อ",
  "run.stopReason": "เหตุผล {reason}",
  "run.operators": "ผู้ปฏิบัติงาน",
  "run.createdBy": "สร้างโดย",
  "run.stoppedBy": "หยุดโดย",
  "run.funding": "เงินทุน",
  "run.budgets": "งบประมาณ",
  "run.orderDistribution": "การกระจายคำสั่ง",
  "run.liveTop": "สด · สูงสุด {count}",
  "run.statsInactive": "สถิติสดมีเฉพาะขณะรันทำงานอยู่",
  "run.activeOrders": "คำสั่งผู้ดูแลสภาพคล่องที่เปิดอยู่",
  "run.activeOrdersInactive": "คำสั่งผู้ดูแลสภาพคล่องที่เปิดอยู่ดูได้เฉพาะขณะรันทำงานอยู่",
  "run.error.activity": "โหลดกิจกรรมคำสั่งไม่สำเร็จ",
  "run.tradeHistory": "ประวัติการซื้อขายของผู้ดูแลสภาพคล่อง",
  "run.tradeHistoryInactive": "ประวัติการซื้อขายของผู้ดูแลสภาพคล่องดูได้เฉพาะขณะรันทำงานอยู่",
  "run.error.tradeHistory": "โหลดประวัติการซื้อขายของผู้ดูแลสภาพคล่องไม่สำเร็จ",
  "run.eventLog": "บันทึกเหตุการณ์",
  "run.noEvents": "ยังไม่มีเหตุการณ์",
  "run.snapshot": "ภาพบันทึกชุดการตั้งค่ารัน",
  "run.orders": "คำสั่ง",
  "run.notional": "มูลค่าตามสัญญา",
  "run.filled": "จับคู่แล้ว: {count}",
  "run.placeAttempts": "พยายามส่งคำสั่ง",
  "run.placeOk": "ส่งสำเร็จ",
  "run.placeFailed": "ส่งล้มเหลว",
  "run.cancelAttempts": "พยายามยกเลิก",
  "run.cancelOk": "ยกเลิกสำเร็จ",
  "run.cancelFailed": "ยกเลิกล้มเหลว",
  "run.placeOkShort": "ส่งสำเร็จ",
  "run.placeFailedShort": "ส่งล้มเหลว",
  "run.cancelOkShort": "ยกเลิกสำเร็จ",
  "run.cancelFailedShort": "ยกเลิกล้มเหลว",
  "run.buyVsSell": "ซื้อ เทียบกับ ขาย",
  "run.makerVsTaker": "ผู้สร้างสภาพคล่องเทียบกับผู้รับสภาพคล่อง",
  "run.buyCount": "ซื้อ {count}",
  "run.sellCount": "ขาย {count}",
  "run.makerCount": "ผู้สร้าง {count}",
  "run.takerCount": "ผู้รับ {count}",
  "run.errorsByCode": "ข้อผิดพลาดแยกตามรหัส",
  "run.topMarkets": "ตลาดที่ใช้งานสูงสุด",
  "run.topMakers": "ผู้สร้างสภาพคล่องที่ใช้งานสูงสุด",
  "run.noActivity": "ยังไม่มีกิจกรรม",
  "run.placed": "ส่งแล้ว",
  "run.updatedSince": "อัปเดต {updated} · เริ่มนับ {since}",
  "run.noActiveOrders": "ไม่มีคำสั่งผู้ดูแลสภาพคล่องที่เปิดอยู่",
  "run.buyBid": "ซื้อ / เสนอซื้อ",
  "run.sellAsk": "ขาย / เสนอขาย",
  "run.openCount": "เปิดอยู่ {count}",
  "run.noOrderSide": "ไม่มีคำสั่ง {side}",
  "run.created": "สร้างเมื่อ",
  "run.filledQty": "จับคู่แล้ว",
  "run.remaining": "คงเหลือ",
  "run.noTrades": "ยังไม่มีรายการซื้อขายของผู้ดูแลสภาพคล่อง",
  "run.matched": "จับคู่เมื่อ",
  "run.updatedTime": "อัปเดต {time}",
  "funding.source": "เงินทุนจาก {account}",
  "funding.worstCase": "กรณีเลวร้ายที่สุด · กระเป๋าใหม่",
  "funding.perAccount": "ต่อบัญชี",
  "funding.accounts": "บัญชี",
  "funding.totalRequired": "ยอดที่ต้องใช้",
  "funding.available": "คงเหลือ",
  "funding.warning": "บัญชีเงินทุนอาจไม่พอสำหรับรันนี้ โปรดเติม {account} ในหน้าคลังเงินของระบบหลังบ้าน กระเป๋าที่มีเงินแล้วจะดึงเฉพาะส่วนขาด และการตรวจตอนเริ่มรันเป็นผลตัดสินสุดท้าย",
  "error.details": "รายละเอียดทางเทคนิค",
  "error.generic": "เกิดข้อผิดพลาด",
  "error.network": "เชื่อมต่อบริการผู้ดูแลสภาพคล่องไม่ได้ โปรดตรวจสอบเครือข่ายแล้วลองใหม่",
  "error.server": "เซิร์ฟเวอร์เกิดข้อผิดพลาด โปรดลองอีกครั้งในภายหลัง",
  "nav.pools": "แหล่งสภาพคล่องการแปลงสกุล",
  "pools.title": "แหล่งสภาพคล่องการแปลงสกุล",
  "pools.intro": "GREEN แปลงเป็น RED และ GOLD ได้ และการแปลงทุกครั้งจ่ายออกจากแหล่งสภาพคล่องของสกุลปลายทางที่เติมไว้ล่วงหน้า ติดตามระดับได้ที่นี่และเติมหรือดึงออกได้ ตัวเลขแต่ละตัวเป็นสกุลเดียวและไม่มีการรวมข้ามแหล่งสภาพคล่อง",
  "pools.notCapital": "แหล่งสภาพคล่องการแปลงสกุลคือภาระผูกพันของแพลตฟอร์มต่อผู้ใช้ที่ถือ GREEN ไม่ใช่เงินทุนของผู้ดูแลสภาพคล่อง จึงไม่นับรวมในยอดสำหรับเทรดหรืองบความเสี่ยง และไม่มีกลยุทธ์ใดใช้เงินนี้ได้",
  "pools.readFailed": "ไม่สามารถอ่านสภาพคล่องได้ อย่าดำเนินการจากตัวเลขเก่า — โปรดโหลดใหม่ก่อน",
  "pools.none": "ระบบบัญชีแยกประเภทรายงานว่าไม่มีแหล่งสภาพคล่องต้นทาง",
  "pools.receiptHeading": "บัญชีรับเงิน",
  "pools.outflowHeading": "การจ่ายออกจากการแปลงสกุลล่าสุด",
  "pools.cardTitle": "แหล่งสภาพคล่อง {currency}",
  "pools.total": "ทั้งหมด",
  "pools.available": "ใช้ได้",
  "pools.reserved": "กันไว้",
  "pools.reservedNote": "ยอดที่กันไว้นับเฉพาะรายการที่ทำงานอยู่ในบัญชีแยกประเภทเท่านั้น ใบเสนอราคาที่ผู้ใช้ยังไม่ยืนยันไม่ได้กันเงินไว้และจะไม่แสดงที่นี่",
  "pools.utilisation": "อัตราการใช้งาน",
  "pools.utilisationUnknown": "ยังไม่มีสภาพคล่องให้ใช้",
  "pools.routeStatus": "สวิตช์เส้นทาง",
  "pools.routeSwitchOn": "เปิดอยู่",
  "pools.routeSwitchOff": "ปิดอยู่",
  "pools.routeUnknown": "ไม่มีข้อมูล",
  "pools.payingOut": "กำลังจ่ายออกอยู่",
  "pools.routeConfigElsewhere": "อัตรา ค่าธรรมเนียม วงเงิน และสวิตช์เส้นทาง ตั้งค่าได้ที่ระบบหลังบ้าน",
  "pools.needPermission": "ต้องมีสิทธิ์จัดการแหล่งสภาพคล่องการแปลงสกุล",
  "pools.stateFunded": "มีเงินแล้ว",
  "pools.stateLow": "เหลือน้อย",
  "pools.stateExhausted": "หมดเกลี้ยง",
  "pools.stateUnfunded": "ยังไม่ได้เติมเงิน",
  "pools.stateReceiving": "กำลังรับเข้า",
  "pools.exhaustedExplain": "แหล่งสภาพคล่องนี้จ่ายออกไม่ได้ การแปลงเป็นสกุลนี้จะล้มเหลวจนกว่าจะเติมเงิน",
  "pools.lowExplain": "สภาพคล่องที่ใช้ได้อยู่ที่หรือต่ำกว่าเกณฑ์ขั้นต่ำ ควรเติมก่อนที่เส้นทางนี้จะหมด",
  "pools.unfundedExplain": "แหล่งสภาพคล่องนี้ยังไม่เคยถูกเติมเงิน เส้นทางของมันจึงยังจ่ายออกไม่ได้",
  "pools.fund": "เติมเงิน",
  "pools.rebalance": "โยกส่วนเกินออก",
  "pools.fundTitle": "เติมเงินเข้าแหล่งสภาพคล่อง {currency}",
  "pools.rebalanceTitle": "โยกส่วนเกินออกจากแหล่งสภาพคล่อง {currency}",
  "pools.fundSubtitle": "โยกมูลค่าจากคลังเข้าสู่แหล่งสภาพคล่อง โดยไม่มีการสร้างเงินใหม่: คลังจะถูกหักตามจำนวนนี้พอดีและเป็นสกุลเดียวกัน",
  "pools.rebalanceSubtitle": "โยกสภาพคล่องส่วนเกินออกจากแหล่งสภาพคล่องกลับไปยังคลัง โดยไม่มีการทำลายมูลค่าใด",
  "pools.currency": "สกุลเงิน",
  "pools.source": "จาก",
  "pools.destination": "ไปยัง",
  "pools.amount": "จำนวน",
  "pools.amountHint": "กรุณากรอกจำนวนที่มากกว่าศูนย์",
  "pools.wireHint": "จำนวนที่ส่งจริงตามสายข้อมูล: {minor}",
  "pools.overdraw": "มากกว่าที่แหล่งสภาพคล่องมีอยู่ ยอดที่กันไว้ค้ำการแปลงที่กำลังดำเนินอยู่",
  "pools.reason": "เหตุผล",
  "pools.reasonPlaceholder": "เหตุผลของการโยกย้ายครั้งนี้",
  "pools.reasonHint": "จำเป็นต้องกรอก ข้อความนี้จะถูกบันทึกในรายการตรวจสอบคู่กับรหัสผู้ดูแลระบบของคุณ",
  "pools.movement": "การโยกย้าย",
  "pools.reference": "รหัสอ้างอิงกันการทำซ้ำ",
  "pools.confirm": "ยืนยันการโยกย้าย",
  "pools.movementFailed": "ไม่สามารถดำเนินการโยกย้ายให้สำเร็จได้",
  "pools.movementsFailed": "ไม่สามารถอ่านประวัติการโยกย้ายได้",
  "pools.noMovements": "ยังไม่มีการโยกย้ายในแหล่งสภาพคล่อง {currency}",
  "pools.colWhen": "เมื่อ",
  "pools.colKind": "ประเภท",
  "pools.colAmount": "จำนวน",
  "pools.colRoute": "จาก → ไปยัง",
  "pools.colReference": "รหัสอ้างอิง",
  "pools.idempotencyNote": "แต่ละแถวอ้างอิงด้วยรหัสกันการทำซ้ำ: การโยกย้ายที่ส่งซ้ำหรือเล่นซ้ำจะปรากฏเพียงครั้งเดียว ไม่ใช่สองครั้ง",
  "paramKind.money": "จำนวนเงิน",
  "accounts.fundingCurrency": "สกุลเงินที่ใช้เติม",
  "accounts.initialFundingHint": "หน่วยเป็น {currency}",
  "accounts.perCurrency": "ยอดคงเหลือแยกตามสกุลเงิน",
  "presets.gameSurfaceOff": "พรีเซ็ตนี้เทรดช่องทาง GAME ซึ่งยังไม่เปิดใช้งานในรุ่นนี้ โปรดแจ้งผู้ดูแลแผนการเปิดใช้งานให้เปิดหน้าจอกลยุทธ์ GAME ก่อนเริ่มรัน",
  "presets.gameNoOptIn": "พรีเซ็ตนี้เทรดช่องทาง GAME แต่ยังไม่มีการยืนยันเข้าร่วม GAME อย่างชัดเจน เซิร์ฟเวอร์จะปฏิเสธ โปรดเปิดพรีเซ็ตและยืนยันเข้าร่วมก่อนเริ่มรัน",
  "presets.tradingMode": "โหมดการเทรด",
  "presets.modeCash": "Cash · ซื้อและจ่ายด้วย GOLD",
  "presets.modeGame": "Game · ซื้อด้วย RED จ่ายเป็น GREEN",
  "overview.activeCash": "รันโหมด Cash",
  "overview.activeGame": "รันโหมด Game",

  "event.PAUSE_REQUESTED": "ขอหยุดพัก",
  "event.PAUSED": "หยุดพักแล้ว",
  "event.RESUME_REQUESTED": "ขอรันต่อ",
  "event.RESUMED": "รันต่อแล้ว",
  "event.RESTART_REQUESTED": "ขอเริ่มใหม่",
  "event.RECOVERED": "กู้คืนจากจุดบันทึกแล้ว",
  "event.SNAPSHOT_CAPTURED": "บันทึกภาพนิ่งสถานะแล้ว",
  "event.CHECKPOINT_SAVED": "บันทึกจุดบันทึกแล้ว",
  "event.CHECKPOINT_RESTORED": "กู้คืนจุดบันทึกแล้ว",
  "event.RECONCILED": "ตรวจสอบคำสั่งต้นทางแล้ว",
  "event.AUTO_START": "ผลการเริ่มอัตโนมัติ",

  // --- SM-538 ---
  "common.retry": "ลองใหม่",
  "data.loadFailed": "ไม่สามารถโหลดข้อมูลล่าสุดได้ กรุณาลองใหม่",
  "data.refreshing": "กำลังรีเฟรชข้อมูล…",
  "data.staleAfterError": "นี่เป็นข้อมูลล่าสุดที่เราโหลดได้ — การรีเฟรชครั้งล่าสุดไม่สำเร็จ",
  "runs.emptyStart": "ยังไม่มีการรัน เริ่มพรีเซ็ตจากหน้าพรีเซ็ตเพื่อสร้างการรันครั้งแรก",
  "accounts.unknownPreset": "ไม่ทราบพรีเซ็ต",
  "overview.autoStartPresets": "เริ่มหลังรีสตาร์ต",
  "overview.noAutoStart": "ยังไม่มีพรีเซ็ตที่เปิดให้เริ่มทำงานหลังรีสตาร์ตบริการ",
  "mode.cash": "Cash",
  "mode.game": "Game",
  "runState.source.live": "ข้อมูลสด",
  "runState.source.snapshot": "ภาพนิ่ง",
  "runState.source.checkpoint": "จุดบันทึกล่าสุด",
  "runState.completeness.complete": "ครบถ้วน",
  "runState.completeness.partial": "ไม่ครบ",
  "runState.completeness.unavailable": "อ่านไม่ได้",
  "runState.completeness.notCaptured": "ไม่ได้บันทึกไว้",
  "runState.stale": "ข้อมูลเก่า",
  "runState.capturedAt": "บันทึกเมื่อ {time}",
  "runState.unavailableBody": "อ่านข้อมูลส่วนนี้ไม่ได้ จึงแสดงว่าอ่านไม่ได้แทนการแสดงเป็นศูนย์ กรุณาลองใหม่หรือตรวจสอบบริการต้นทาง",
  "runState.notCapturedBody": "การรันนี้ไม่มีการบันทึกสถานะไว้ จึงไม่มีข้อมูลให้แสดง ซึ่งไม่ได้หมายความว่าการรันนี้ไม่มีรายการใดเลย",
  "runState.sectionFailed": "โหลดข้อมูลส่วนนี้ไม่สำเร็จ ส่วนอื่นไม่ได้รับผลกระทบ",
  "runState.tab.orders": "คำสั่ง",
  "runState.tab.positions": "สถานะถือครอง",
  "runState.tab.trades": "รายการซื้อขาย",
  "runState.tab.balances": "ยอดคงเหลือ",
  "runState.noPositions": "ไม่มีสถานะถือครองที่เปิดอยู่",
  "runState.noBalances": "ไม่มีกระเป๋าเงินให้แสดง",
  "runState.balanceUnavailable": "อ่านไม่ได้",
  "runState.balanceUnavailableHint": "อ่านกระเป๋าเงินนี้ไม่ได้ ไม่ได้หมายความว่ายอดเป็นศูนย์",
  "runState.col.mode": "โหมด",
  "runState.col.currency": "สกุลเงิน",
  "runState.col.channel": "ช่องทาง",
  "runState.col.scope": "ขอบเขต",
  "runState.col.reserved": "ถูกกันไว้",
  "runState.col.direction": "ทิศทาง",
  "runState.pageRange": "{start}-{end} จาก {total}",
  "lifecycle.startRun": "เริ่มการรัน",
  "lifecycle.pause": "หยุดพักการรัน",
  "lifecycle.resume": "รันต่อ",
  "lifecycle.stop": "หยุดการรัน",
  "lifecycle.restartFromCheckpoint": "เริ่มใหม่จากจุดบันทึก",
  "lifecycle.startFresh": "เริ่มใหม่จากพรีเซ็ต",
  "lifecycle.pausing": "กำลังหยุดพัก: ปิดการวางคำสั่งใหม่และยกเลิกคำสั่งที่ค้างอยู่…",
  "lifecycle.resuming": "กำลังรันต่อ: ตรวจสอบคำสั่งต้นทางก่อนเสนอราคาอีกครั้ง…",
  "lifecycle.stopping": "กำลังหยุด: ปิดการทำงานและบันทึกภาพนิ่ง…",
  "lifecycle.confirmPause": "หยุดพักการรันนี้หรือไม่ คำสั่งที่ค้างอยู่ {count} รายการจะถูกยกเลิกและจะไม่มีการวางคำสั่งใหม่ สถานะถือครองและยอดคงเหลือจะไม่ถูกแตะต้อง และการรันยังคงถือบัญชีและงบประมาณไว้เพื่อให้รันต่อได้",
  "lifecycle.confirmStop": "หยุด {preset} ({mode}) หรือไม่ คำสั่งที่ค้างอยู่ {count} รายการจะถูกยกเลิก ระบบจะบันทึกภาพนิ่งสุดท้าย และการรันจะกลายเป็นประวัติถาวรที่ย้อนกลับไม่ได้ สถานะถือครองและยอดคงเหลือจะไม่ถูกแตะต้อง",
  "lifecycle.confirmPauseUnknown": "หยุดพักการรันนี้หรือไม่ คำสั่งที่ค้างอยู่จะถูกยกเลิกและจะไม่มีการวางคำสั่งใหม่ สถานะถือครองและยอดคงเหลือจะไม่ถูกแตะต้อง และการรันยังคงถือบัญชีและงบประมาณไว้เพื่อให้รันต่อได้",
  "lifecycle.confirmStopUnknown": "หยุด {preset} ({mode}) หรือไม่ คำสั่งที่ค้างอยู่จะถูกยกเลิก ระบบจะบันทึกภาพนิ่งสุดท้าย และการรันจะกลายเป็นประวัติถาวรที่ย้อนกลับไม่ได้ สถานะถือครองและยอดคงเหลือจะไม่ถูกแตะต้อง",
  "lifecycle.confirmRestartCheckpoint": "เริ่มใหม่จากจุดบันทึกเมื่อ {time} หรือไม่ ระบบจะสร้างความพยายามใหม่ที่เชื่อมโยงกัน โดยสานต่องบประมาณและสถานะกลยุทธ์ของการรันที่ล้มเหลว การรันที่ล้มเหลวจะถูกเก็บไว้ตามเดิมทั้งหมด",
  "lifecycle.confirmRestartFresh": "เริ่มใหม่จากพรีเซ็ตนี้หรือไม่ ระบบจะสร้างความพยายามใหม่โดยไม่กู้คืนสถานะใด งบประมาณ สถานะกลยุทธ์ และตัวนับคำสั่งจะเริ่มต้นใหม่ทั้งหมด การรันที่ล้มเหลวจะถูกเก็บไว้ตามเดิม",
  "lifecycle.checkpointUnknownTime": "เวลาที่ไม่ทราบ",
  "lifecycle.blocked.noCheckpoint": "การรันนี้ไม่มีจุดบันทึก จึงเริ่มใหม่จากจุดบันทึกไม่ได้ กรุณาเริ่มใหม่จากพรีเซ็ตแทน",
  "lifecycle.blocked.incompatibleVersion": "จุดบันทึกของการรันนี้ถูกเขียนด้วยเวอร์ชันอื่นและกู้คืนไม่ได้ กรุณาเริ่มใหม่จากพรีเซ็ตแทน",
  "lifecycle.blocked.configChanged": "พรีเซ็ตถูกแก้ไขหลังการรันล้มเหลว จุดบันทึกจึงไม่ตรงกันอีก กรุณาเริ่มใหม่จากพรีเซ็ตแทน",
  "lifecycle.blocked.generic": "การรันนี้เริ่มใหม่จากจุดบันทึกไม่ได้ กรุณาเริ่มใหม่จากพรีเซ็ตแทน",
  "lifecycle.error.pause": "หยุดพักการรันไม่สำเร็จ",
  "lifecycle.error.resume": "รันต่อไม่สำเร็จ",
  "lifecycle.error.restart": "เริ่มการรันใหม่ไม่สำเร็จ",
  "identity.presetId": "พรีเซ็ต",
  "identity.runId": "การรัน",
  "identity.copyAria": "คัดลอกรหัส {label} {value}",
  "identity.resolved": "ชื่อจากการค้นหา",
  "identity.resolvedHint": "การรันนี้เริ่มก่อนที่ระบบจะบันทึกชื่อ จึงแสดงชื่อพรีเซ็ตปัจจุบัน",
  "identity.fallback": "ไม่มีชื่อ",
  "identity.fallbackHint": "ไม่สามารถค้นหาพรีเซ็ตของการรันนี้ได้ จึงแสดงชื่อแทน",
  "presetDetail.tab.overview": "ภาพรวม",
  "presetDetail.tab.state": "สถานะปัจจุบัน",
  "presetDetail.tab.history": "ประวัติการรัน",
  "presetDetail.tab.config": "การตั้งค่า",
  "presetDetail.liveStateTitle": "สถานะการรัน",
  "presetDetail.openRun": "เปิดรายละเอียดการรัน",
  "presetDetail.currentRun": "การรันปัจจุบัน",
  "presetDetail.latestRun": "การรันล่าสุด",
  "presetDetail.noRunsYet": "ยังไม่มีการรัน เริ่มพรีเซ็ตนี้เพื่อสร้างการรันครั้งแรก",
  "presetDetail.showingLatestTerminal": "พรีเซ็ตนี้ไม่ได้ทำงานอยู่ กำลังแสดงภาพนิ่งของการรันครั้งล่าสุดที่บันทึกเมื่อ {time}",
  "presetDetail.checkpointFreshness": "จุดบันทึก",
  "presetDetail.noCheckpoint": "ไม่มี",
  "presetDetail.configImmutableNote": "การแก้ไขพรีเซ็ตมีผลกับการรันครั้งถัดไปเท่านั้น ทุกการรันเก็บภาพการตั้งค่าที่ใช้เริ่มไว้ จึงไม่กระทบการรันที่กำลังทำงานหรือการรันในอดีต",
  "presetDetail.error.load": "โหลดพรีเซ็ตไม่สำเร็จ",
  "presetDetail.error.history": "โหลดประวัติการรันไม่สำเร็จ",
  "history.currentRun": "การรันปัจจุบัน",
  "history.previousAttempts": "ความพยายามก่อนหน้า",
  "history.emptyNoRuns": "ยังไม่มีการรัน เริ่มพรีเซ็ตนี้เพื่อสร้างการรันครั้งแรก",
  "history.emptyFiltered": "ไม่มีการรันที่ตรงกับ {filters}",
  "history.clearFilters": "ล้างตัวกรอง",
  "history.recoveryChain": "สายการกู้คืน · {count} ครั้ง",
  "history.attemptOf": "ครั้งที่ {attempt} กู้คืนจากการรัน {source}",
  "history.snapshotCaptured": "บันทึกแล้ว",
  "history.col.run": "การรัน",
  "history.col.duration": "ระยะเวลา",
  "history.col.operator": "ผู้เริ่มหรือผู้หยุด",
  "history.col.snapshot": "ภาพนิ่ง",
  "history.durationMinutes": "{minutes} นาที",
  "history.durationHours": "{hours} ชม. {minutes} นาที",
  "history.filter.active": "กำลังทำงาน",
  "history.filter.paused": "หยุดพัก",
  "history.filter.mode": "โหมดการเทรด",
  "history.filter.runId": "รหัสการรัน",
  "history.filter.runIdPlaceholder": "รหัสการรันเต็มหรือบางส่วน",
  "history.filter.from": "ตั้งแต่",
  "history.filter.to": "ถึง",
  "history.filter.runIdSummary": "รหัสการรันที่มี {query}",
  "history.filter.fromSummary": "ตั้งแต่ {date}",
  "history.filter.toSummary": "ถึง {date}",
  "recovery.title": "การกู้คืน",
  "recovery.attempt": "ครั้งที่",
  "recovery.rootRun": "ความพยายามแรกของสายนี้",
  "recovery.checkpointStage": "ขั้นของจุดบันทึก",
  "recovery.attemptsTitle": "ความพยายามทั้งหมด",
  "autoStart.title": "การรีสตาร์ตบริการ",
  "autoStart.toggleLabel": "เริ่มทำงานอัตโนมัติหลังรีสตาร์ตบริการ",
  "autoStart.toggleHelp": "เปิดใช้ได้หลายพรีเซ็ต แต่ละพรีเซ็ตเริ่มทำงานแยกกัน พรีเซ็ตที่ขัดแย้งจะไม่ทำให้พรีเซ็ตอื่นหยุด",
  "autoStart.enable": "เปิดการเริ่มอัตโนมัติ",
  "autoStart.disable": "ปิดการเริ่มอัตโนมัติ",
  "autoStart.willStart": "เริ่มเมื่อรีสตาร์ต",
  "autoStart.willStartHint": "พรีเซ็ตนี้จะเริ่มทำงานอัตโนมัติหลังรีสตาร์ตบริการ",
  "autoStart.error": "เปลี่ยนการตั้งค่าเริ่มอัตโนมัติไม่สำเร็จ",
  "autoStart.resultsTitle": "การรีสตาร์ตครั้งล่าสุด",
  "autoStart.bootedAt": "บริการรีสตาร์ตเมื่อ {time}",
  "autoStart.outcome.STARTED": "สร้างรันแล้ว",
  "autoStart.outcome.RECOVERED": "สร้างรันกู้คืนแล้ว",
  "autoStart.outcome.SKIPPED": "ข้ามไป",
  "autoStart.outcome.FAILED": "ล้มเหลว",
  "autoStart.resultColumn": "ผลการรีสตาร์ต",
  "autoStart.resultColumnHint": "สิ่งที่การรีสตาร์ตทำกับพรีเซ็ตนี้ บันทึกครั้งเดียวและไม่เปลี่ยนแปลง สถานะของรันเองอยู่ในคอลัมน์ถัดไป",
  "autoStart.runStatusColumn": "สถานะรัน",
  "autoStart.runStateUnknown": "อ่านสถานะรันไม่ได้",
  "autoStart.noRun": "ไม่มีรัน",
  "presets.gameBlockedTitle": "เริ่มพรีเซ็ตนี้จากคอนโซลนี้ไม่ได้",
  "presets.gameBlockedDismiss": "ปิด",
  "fundingConfirm.title": "ตรวจสอบเงินทุนก่อนเริ่ม",
  "fundingConfirm.subtitle": "ทุกสกุลเงินที่รันนี้ต้องใช้ถูกตรวจสอบแยกกัน เทียบกับบัญชีที่ดึงเงินมา",
  "fundingConfirm.ready": "ยอดที่ต้องมีทุกรายการเพียงพอ การเริ่มจะโอนเฉพาะส่วนขาดของแต่ละกระเป๋า",
  "fundingConfirm.short": "มีอย่างน้อยหนึ่งยอดที่ไม่พอ การเริ่มจะถูกปฏิเสธก่อนมีการโอนใด ๆ เว้นแต่รันไทม์จะครอบคลุมได้",
  "fundingConfirm.planNote": "การเริ่มจะแนบลายนิ้วมือของแผนนี้ ({plan}) ไปด้วย จึงดำเนินการตามแถวที่แสดงไว้ตรงนี้เท่านั้น ไม่เช่นนั้นจะถูกปฏิเสธ",
  "fundingConfirm.startAnyway": "เริ่มต่อไป",
  "fundingConfirm.pricing": "กำลังคำนวณเงินทุนของรัน…",
  "fundingConfirm.unverified": "อ่านยอดคงเหลือบางรายการไม่ได้ การตรวจสอบนี้จึงยังไม่สมบูรณ์ รันไทม์จะตรวจสอบทุกยอดอีกครั้งก่อนมีการโอนใด ๆ",
  "funding.reserveUnknown": "ยังไม่ได้ตรวจสอบ",
  "funding.afterStart": "หลังเริ่ม",
  "funding.topUp": "เติม",
  "capabilities.title": "ความสามารถที่มีผลจริง",
  "capabilities.subtitle": "สิ่งที่รันไทม์ market-maker โหลดไว้ เทียบกับรุ่นบิลด์ของคอนโซลนี้",
  "capabilities.gameRuntime": "การเทรด GAME (รันไทม์)",
  "capabilities.gameConsole": "หน้าจอ GAME (คอนโซลนี้)",
  "capabilities.autoTopUp": "เติมอัตโนมัติจากกองกลาง",
  "capabilities.autoTopUpCeiling": "เพดานการเติม",
  "capabilities.noCeiling": "ไม่จำกัด",
  "capabilities.fundingMode": "รูปแบบเงินทุน",
  "capabilities.maxRuns": "จำนวนรันพร้อมกันสูงสุด",
  "capabilities.on": "เปิด",
  "capabilities.off": "ปิด",
  "capabilities.drift": "คอนโซลนี้กับรันไทม์ไม่ตรงกันเรื่อง GAME พรีเซ็ต GAME จะถูกปฏิเสธโดยฝั่งที่ปิดอยู่",
  "capabilities.unavailable": "รันไทม์ไม่ได้รายงานความสามารถ (เซิร์ฟเวอร์รุ่นเก่า)",
  "overview.mode": "โหมดการเทรด",
  "overview.currencies": "สกุลเงิน",
  "overview.currencyPair": "ซื้อด้วย {debit} · จ่ายเป็น {payout}",
  "overview.totalRuns": "จำนวนการรัน",
  "overview.failedRuns": "การรันที่ล้มเหลว",
  "overview.lastStarted": "เริ่มครั้งล่าสุด",
  "overview.updatedBy": "{time} โดย {who}",
  "run.stateTitle": "สถานะการรัน",
  "run.openPreset": "เปิดพรีเซ็ต",
  "run.lifecycleTimes": "วงจรชีวิต",
  "run.pausedAt": "หยุดพักเมื่อ",
  "run.resumedAt": "รันต่อเมื่อ",

  // --- SM-525: dual-mode execution -------------------------------------
  "mode.all": "ทั้งหมด",
  "mode.filterAria": "กรองตามโหมดการเทรด",
  "mode.currencyHint": "ซื้อด้วย {debit} และจ่ายออกเป็น {payout}",
  "mode.debits": "ซื้อด้วย",
  "mode.pays": "จ่ายเป็น",
  "mode.column": "โหมด",
  "mode.presetIs": "พรีเซ็ตนี้ทำงานในโหมด {mode}",
  "mode.presetLocked": "พรีเซ็ตหนึ่งชุดมีโหมดการเทรดเดียว และผสมตราสารจากทั้งสองโหมดไม่ได้ หากต้องการรันทั้งสองช่องทางด้วยบัญชีนี้ ให้สร้างพรีเซ็ตอีกชุดในโหมดที่เหลือแล้วเริ่มเป็นรันแยกต่างหาก",
  "mode.gameOptIn": "ข้าพเจ้าอนุญาตให้พรีเซ็ตนี้เทรดช่องทาง GAME ด้วย RED และ GREEN",
  "mode.gameOptInHint": "ต้องยืนยันก่อนจึงจะบันทึกหรือเริ่มพรีเซ็ตโหมด Game ได้ การเข้าร่วม Game ไม่เคยสืบทอดโดยอัตโนมัติ สำเนาของพรีเซ็ต Game จะถามยืนยันใหม่ทุกครั้ง",
  "mode.gameSurfaceOff": "รุ่นนี้ยังไม่เปิดใช้งานโหมด Game จึงเริ่มพรีเซ็ตโหมด Game จากคอนโซลนี้ไม่ได้",
  "mode.changeWarning": "การสลับโหมดจะล้างรายการตราสารที่เลือกไว้ เพราะตลาดที่ใช้ได้ในโหมด {from} ไม่ใช่ชุดเดียวกับในโหมด {to}",
  "instruments.presetMode": "โหมดของพรีเซ็ต",
  "instruments.modeTagAria": "โหมดการเทรด",
  "instruments.selectAllCash": "เลือกตลาด Cash ทั้งหมด",
  "instruments.selectAllGame": "เลือกตลาด Game ทั้งหมด",
  "instruments.clearSelection": "ล้างรายการที่เลือก",
  "instruments.snapshotNote": "การเลือกทั้งหมดจะบันทึกเฉพาะตลาดที่แสดงอยู่ ณ ตอนนี้ ตลาดที่เผยแพร่ภายหลังจะไม่ถูกเพิ่มเข้าพรีเซ็ตนี้เอง หากต้องการรวมด้วยให้กดเลือกทั้งหมดอีกครั้ง",
  "instruments.ineligible": "ใช้ไม่ได้ในโหมด {mode}",
  "instruments.eligibleCount": "เลือกได้ {count} รายการในโหมด {mode}",
  "instruments.noneForMode": "ยังไม่มีตลาดที่เทรดได้ในโหมด {mode} โปรดเปิดช่องทาง Game ของตลาดในแคตตาล็อกหลังบ้านแล้วโหลดหน้านี้ใหม่",
  "instruments.excludedNote": "มี {count} ตลาดในรายการนี้ที่เลือกไม่ได้ในโหมด {mode} จึงไม่ถูกรวมไว้",
  "runs.filter.modeAria": "กรองรันตามโหมดการเทรด",
  "runs.concurrentNote": "บัญชีเดียวรันโหมด Cash และ Game พร้อมกันได้ โดยจะแสดงเป็นคนละแถวและหยุดแยกจากกัน",
  "presets.modeColumn": "โหมด",
  "editor.tradingModeTitle": "โหมดการเทรด",
  "editor.tradingModeHint": "พรีเซ็ตหนึ่งชุดทำงานในโหมดเดียวเท่านั้น โหมด Cash ซื้อด้วย GOLD และจ่ายเป็น GOLD ส่วนโหมด Game ซื้อด้วย RED และจ่ายเป็น GREEN ไม่มีโหมดรวม หากต้องการทั้งสองโหมดให้เริ่มพรีเซ็ตสองชุด",
  "editor.selectAllForMode": "เลือกตลาด {mode} ทั้งหมด",
  "funding.requirementsTitle": "ยอดคงเหลือที่ต้องมี",
  "funding.purposeExecution": "เงินทุนในกระเป๋า",
  "funding.purposeRewards": "กองรางวัล",
  "funding.required": "ต้องมี",
  "funding.availableUnknown": "อ่านค่าไม่ได้",
  "funding.perCurrencyNote": "แต่ละสกุลเงินถูกตรวจสอบแยกกัน ยอดเกินของสกุลหนึ่งไม่ใช้ชดเชยยอดขาดของอีกสกุลหนึ่ง",

  // --- SM-506: per-reserve funding -------------------------------------
  "funding.poolDraw": "หักจากกองกลาง",
  "funding.reservesTitle": "เงินสำรองของผู้ดูแลสภาพคล่อง",
  "funding.reservesNote": "ผู้ดูแลสภาพคล่องแต่ละรายใช้เงินสำรองของตนเอง ยอดในกองกลางไม่ไหลลงสู่บัญชีลูก ดังนั้นกองกลางที่มีเงินพอจึงไม่ได้แปลว่าเงินสำรองที่ว่างเปล่าจะใช้งานได้",
  "funding.reserveOk": "มีเงินพอ",
  "funding.reserveTopUp": "เติมอัตโนมัติ",
  "funding.reserveBlocked": "ไม่พอ",
  "funding.shortfall": "ขาดอีก",

  // --- SM-564: account detail -------------------------------------------
  "accounts.openDetail": "เปิดบัญชีนี้",
  "accounts.currency.label": "สกุลเงิน",
  "accounts.currency.aria": "สกุลเงินที่ใช้โอน",
  "accounts.currency.hint": "กระเป๋าทั้งสองฝั่งเคลื่อนไหวในสกุลเงินเดียวนี้ ไม่มีการแปลงสกุลเงิน",
  "accounts.currency.reserveMissing": "เงินสำรองนี้ยังไม่มีกระเป๋า {currency} กรุณาซ่อมแซมสกุลเงินของเงินสำรองจากหน้ารายการบัญชีก่อนโอน {currency}",
  "accountDetail.notFound": "ไม่พบบัญชีผู้ดูแลสภาพคล่องตามรหัสนี้",
  "accountDetail.notFoundHint": "บัญชีอาจถูกลบไปแล้ว หรือลิงก์อาจล้าสมัย ไม่มีการเปลี่ยนแปลงใดในหน้านี้",
  "accountDetail.backToList": "กลับไปยังรายการบัญชี",
  "accountDetail.tabsAria": "ส่วนของบัญชี",
  "accountDetail.tab.trading": "การซื้อขาย",
  "accountDetail.tab.balances": "ยอดคงเหลือ",
  "accountDetail.tab.runs": "รอบการทำงาน",
  "accountDetail.section.orders": "คำสั่งที่เปิดอยู่",
  "accountDetail.section.positions": "สถานะถือครอง",
  "accountDetail.section.history": "ประวัติคำสั่ง",
  "accountDetail.section.trades": "รายการซื้อขาย",
  "accountDetail.currencyFilterAria": "กรองตามสกุลเงิน",
  "accountDetail.allCurrencies": "ทั้งหมด",
  "accountDetail.currencyNote": "ทุกจำนวนแสดงในสกุลเงินของรายการนั้นเอง ไม่มีการรวมสกุลเงินเข้าด้วยกัน ตัวกรองจะแสดงเฉพาะสมุดคำสั่งที่ซื้อขายในสกุลเงินที่เลือก",
  "accountDetail.header.status": "สถานะบัญชี",
  "accountDetail.header.reserve": "เงินสำรอง",
  "accountDetail.header.activeRuns": "รอบที่กำลังทำงาน",
  "accountDetail.col.occurred": "เกิดขึ้นเมื่อ",
  "accountDetail.col.reason": "เหตุผล",
  "accountDetail.col.direction": "ทิศทาง",
  "accountDetail.col.amount": "จำนวนเงิน",
  "accountDetail.col.kind": "ประเภท",
  "accountDetail.col.route": "จาก → ไป",
  "accountDetail.col.txId": "รหัสรายการ",
  "accountDetail.col.reserveAvailable": "เงินสำรองที่ใช้ได้",
  "accountDetail.col.reserveWallet": "กระเป๋าเงินสำรอง",
  "accountDetail.col.role": "บทบาท",
  "accountDetail.col.preset": "พรีเซ็ต",
  "accountDetail.col.started": "เริ่ม",
  "accountDetail.col.stopped": "หยุด",
  "accountDetail.noOrders": "บัญชีนี้ไม่มีคำสั่งที่เปิดอยู่",
  "accountDetail.noPositions": "บัญชีนี้ไม่มีสถานะถือครอง",
  "accountDetail.noHistory": "บัญชีนี้ไม่มีประวัติคำสั่ง",
  "accountDetail.noTrades": "บัญชีนี้ไม่มีรายการซื้อขาย",
  "accountDetail.noMovements": "ยังไม่มีการเคลื่อนไหวของยอด {currency}",
  "accountDetail.noRuns": "ยังไม่มีรอบการทำงานที่ใช้บัญชีนี้",
  "accountDetail.balances.title": "กระเป๋าเงิน",
  "accountDetail.balances.historyTitle": "การเคลื่อนไหวของยอดคงเหลือ",
  "accountDetail.balances.historyCurrency": "สกุลเงินของสมุดบัญชี",
  "accountDetail.balances.readOnly": "คุณสามารถดูยอดคงเหลือและประวัติได้ แต่บทบาทของคุณไม่อนุญาตให้โอนเงิน",
  "accountDetail.balances.provisioned": "มีกระเป๋าแล้ว",
  "accountDetail.balances.notProvisioned": "ไม่มีกระเป๋า",
  "accountDetail.movement.credit": "รับเข้า",
  "accountDetail.movement.debit": "จ่ายออก",
  "accountDetail.movement.hold": "กันไว้",
  "accountDetail.runs.filter.all": "ทั้งหมด",
  "accountDetail.runs.filter.active": "กำลังทำงาน",
  "accountDetail.runs.filter.history": "ประวัติ",
  "accountDetail.runs.role.maker": "ผู้ดูแลสภาพคล่อง",
  "accountDetail.runs.role.taker": "ผู้รับราคา",
  "accountDetail.runs.role.selected": "ถูกเลือก",
};
